module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_ks_zddd@2x.39bb1840.png";